var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.603,
    height: 23.71,
    viewBox: "0 0 12.603 23.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_45301",
    "data-name": "Path 45301",
    d: "M1534.912,5408.276l.653-4.259h-4.085v-2.764a2.129,2.129,0,0,1,2.4-2.3h1.857v-3.626a22.7,22.7,0,0,0-3.3-.287c-3.365,0-5.564,2.04-5.564,5.731v3.246h-3.741v4.259h3.741v10.293a14.756,14.756,0,0,0,4.6,0v-10.293Z",
    transform: "translate(-1523.135 -5395.04)",
    fill: "#ef7b13"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookOrange);
export default __webpack_public_path__ + "static/media/facebook_orange.b0edf27e1cb2bb17ce3cb5f1790ab786.svg";
export { ForwardRef as ReactComponent };